import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import NomenclaturesTemplatesCategoryApiService from '@/modules/settings/services/NomenclaturesTemplatesCategoryApiService';
import {useGetOneNomenclaturesTemplatesCategory} from '@/modules/settings/hooks/useNomenclaturesTemplatesCategory';

// eslint-disable-next-line no-unused-vars
const SelectUserCategory = ({ value, onChange, translation, form, fieldKey, setCategory, ...props }) => {

  const onChangeValues = useCallback((value) => {
    const temp = form.getFieldValue('registersAccess');
    if (!temp[fieldKey]) {
      temp[fieldKey] = {};
    }
    temp[fieldKey].category = value;
    setCategory && setCategory(value);
    form.setFieldsValue({registersAccess: temp});
    onChange && onChange(temp);
  }, [fieldKey, form, onChange, setCategory]);

  return (
    <SelectElementCmp
      queryKey={`user-categories-select-${fieldKey}`}
      key={`user-categories-select-${fieldKey}`}
      service={NomenclaturesTemplatesCategoryApiService}
      customMethod={'/ms-core/api/categories/search-categories-subcategories'}
      additionalParams={{type: 'REGISTER'}}
      includeValue={''}
      value={typeof value === 'object' ? value?.name : value}
      onChange={onChangeValues}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      placeholder={translation('placeholderSelectServices')}
      {...props}
    />
  );
};

SelectUserCategory.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  form: PropTypes.object,
  translation: PropTypes.func,
  fieldKey: PropTypes.string,
  setCategory: PropTypes.func
};
SelectUserCategory.defaultProps = {
  entity: {},
};

export default memo(SelectUserCategory);

const CategoryUserView = ({value}) => {

  const {data} = useGetOneNomenclaturesTemplatesCategory({id: value?._id ? value?._id : value});

  return (
    <div className={'italic text-primary'}>
      {data?.data?.name || 'N/A'}
    </div>
  );
};

CategoryUserView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * */
export const renderUserCategory = (text) => {
  return (
    <CategoryUserView value={text}/>
  );
};
